<template>
  <div class="container-fluid main_content">
    <location-line/>
    <router-view/>
  </div>
</template>

<script>
import LocationLine from '@/components/LocationLine'

export default {
  name: 'CarMain',
  components: {
    LocationLine
  }
}
</script>

<style scoped>
  
</style>
